import { connect } from 'react-redux'
import { ProfilePage } from '../components'

const mapStateToProps = (state, ownProps) => {
  return ({
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfilePage)


// WEBPACK FOOTER //
// ./src/Pages/User/containers/ProfilePage.js